import React from 'react';
import { useTranslation } from 'react-i18next';
import { QButton } from '@qualio/ui-components';
import { Form } from '../../../../types';

type EventFormViewHeaderSendForReviewButtonProps = {
  data: Form;
  shouldShowActionButton: boolean;
  callback: () => void;
  isDisabled?: boolean;
  isApiLoading?: boolean;
};

export const HeaderSendForReviewButton: React.FC<EventFormViewHeaderSendForReviewButtonProps> = ({
  data,
  shouldShowActionButton = false,
  callback,
  isDisabled = false,
  isApiLoading = false,
}) => {
  const { t } = useTranslation();
  const shouldShowSendForReviewButton = ['draft'].includes(data.status) && shouldShowActionButton;

  return shouldShowSendForReviewButton ? (
    <QButton
      aria-label="send-for-review"
      data-cy="send-for-review"
      variant="outline"
      isLoading={isApiLoading}
      isDisabled={isDisabled}
      onClick={callback}
    >
      {t('forms.actions.sendForReview')}
    </QButton>
  ) : null;
};
